import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Input from "./common/Input";
import { toast } from "react-toastify";
import moment from "moment";

import Lottie from "lottie-react";
import { json2xml } from "xml-js";
import Joi from "joi-browser";
import {
  getFieldDate,
  getFieldName,
  formatDate,
  createEntity,
} from "../scripts/helperScripts";
import {
  getReferral,
  getReferringAgencies,
  getUserProgramUnits,
  getContact,
  getSoarCorrespondence,
  saveReferral,
  searchContact,
  sendEmail,
  writeErrorLog,
} from "./services/soar";
import contactOptionsets from "../options/contact.json";
import * as referralLoading from "../animations/profile.json";
import Documents from "./sharepoint/Documents";
import Select from "./common/Select";
import TextArea from "./common/TextArea";
import PhoneInput from "./common/PhoneInput";
import ReferralDecisionModal from "./common/ReferralDecisionModal";
import Contact from "./Contact";
import SOARCorrespondenceCard from "./common/SOARCorrespondenceCard";
import EntityHeader from "./common/EntityHeader";
import ReferralCustomRender from "./common/ReferralCustomRender";
import contactOptionSets from "./../options/contact.json";

const Referral = () => {
  const { referralID } = useParams();
  const [referralData, setReferralData] = useState({});
  const [programUnitOptions, setProgramUnitOptions] = useState([]);
  const [programUnits, setProgramUnits] = useState([]);
  const [referringAgencySearchQuery, setReferringAgencySearchQuery] =
    useState("");
  const [referringAgencyOptions, setReferringAgencyOptions] = useState([]); // 5
  const [referringWorkerSearchQuery, setReferringWorkerSearchQuery] =
    useState("");
  const [referringWorkerOptions, setReferringWorkerOptions] = useState([]);
  const [isReferringWorkerOpen, setIsReferringWorkerOpen] = useState(false);
  const [referringWorkerData, setReferringWorkerData] = useState({});
  const [referringWorkerErrors, setReferringWorkerErrors] = useState([]); // 10
  const [contact, setContact] = useState({});
  const [contactLoaded, setContactLoaded] = useState(false);
  const [forceContactSave, setForceContactSave] = useState(false);
  const [correspondence, setCorrespondence] = useState([]);
  const [correspondenceLoaded, setCorrespondenceLoaded] = useState(false); // 15
  const [dynamicData, setDynamicData] = useState({});
  const [referralStatus, setReferralStatus] = useState();
  const [isRequestAgencyOpen, setIsRequestAgencyOpen] = useState(false);
  const [agencyInfo, setAgencyInfo] = useState();
  const [isReferralDecisionOpen, setIsReferralDecisionOpen] = useState(false); // 20
  const [loaded, setLoaded] = useState(false);
  const [errors, setErrors] = useState({});
  const isMountedRef = useRef(true);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [activeTab, setActiveTab] = useState("ClientInfo");
  const navigate = useNavigate();
  const location = useLocation();
  var org =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "ReactLive"
      : "ReactDev";
  var logOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "ReactLive"
      : process.env.REACT_APP_ENVIRONMENT === "DevOps Test"
      ? "ReactTest"
      : process.env.REACT_APP_ENVIRONMENT === "Development"
      ? "ReactDev"
      : "ReactIdk";

  //Validation Schema
  const joiSchema = {
    FirstName: Joi.string().allow(""),
    MiddleName: Joi.string().allow(""),
    LastName: Joi.string().required().label("Last Name"),
    GenderValue: Joi.string().required().label("Sex"),
    DOB: Joi.date()
      .max("now")
      .min(new Date("1/1/1900"))
      .label("DOB")
      .allow("")
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            case "date.max":
              error.message = `DOB cannot be future dated`;
              break;
            case "date.min":
              error.message = `DOB cannot be before 1/1/1900`;
              break;
            default:
              return error.message;
          }
        });
        return errors;
      }),
    SSN: Joi.string().allow(""),
    SOARContactId: Joi.string().allow(""),
    ProposedProgram: Joi.string().allow(""),
    SOARClientProgramId: Joi.string().allow(""),
    DynamicFields: Joi.string().allow(""),
    Status: Joi.string().allow(""),
    CreatedById: Joi.string().allow(""),
    ModifiedById: Joi.string().allow(""),
    DeferralReason: Joi.string().allow(""),
    DateofReferral: Joi.date()
      .max("now")
      .min(new Date("1/1/1900"))
      .label("Date of Referral")
      .allow("")
      .error((errors) => {
        errors.forEach((error) => {
          switch (error.type) {
            case "date.max":
              error.message = `Date of Referral cannot be future dated`;
              break;
            case "date.min":
              error.message = `Date of Referral cannot be before 1/1/1900`;
              break;
            default:
              return error.message;
          }
        });
        return errors;
      }),
    ReferringAgency: Joi.string().allow(""),
  };

  const referringWorkerSchema = {
    FirstName: Joi.string().label("First Name").required(),
    LastName: Joi.string().label("Last Name").required(),
    Email: Joi.string().label("Email").required(),
    MobilePhone: Joi.string().label("Mobile Phone").required(),
    DateOfBirth: Joi.string().label("Date of Birth").allow(""),
    Gender: Joi.string().label("Gender").allow(""),
    County: Joi.string().label("County").allow(""),
  };

  //Route Access Protection
  useEffect(() => {
    if (!safyInfo) navigate("/");

    const modules = safyInfo.user.modules;
    if (
      modules.includes("My Caseload") === false &&
      modules.includes("Team Caseload") === false
    ) {
      navigate("/");
    }
  });

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    getUserProgramUnits(safyInfo.user.safyInfo.BusinessUnitIdName).then(
      (response) => {
        if (isMountedRef.current) {
          const options = response
            .filter(
              (programUnit) =>
                programUnit.ccx_expdate === undefined &&
                getFieldName(programUnit.ccx_programtype) !== "Foster Home" &&
                safyInfo.user.divisions.includes(
                  getFieldName(programUnit.ccx_facility)
                )
            )
            .map((programUnit) => {
              return {
                _id: programUnit.ccx_unitid.replace(/[{}]/g, ""),
                name: programUnit.ccx_name,
                referralConfig: programUnit.sor_referralconfig
                  ? JSON.parse(programUnit.sor_referralconfig)
                  : { referral: {} },
                state: getFieldName(programUnit["facility.ccx_agency"]).split(
                  " of "
                )[1],
              };
            });
          setProgramUnitOptions(options);
          setProgramUnits(response);
        }
      }
    );

    getReferringAgencies(safyInfo.user.safyInfo.BusinessUnitIdName).then(
      (response) => {
        if (isMountedRef.current && response) {
          const options = response.map((referringAgency) => ({
            _id: referringAgency.accountid,
            name: referringAgency.name,
          }));

          setReferringAgencyOptions(options);
        }
      }
    );
  }, []);

  useEffect(() => {
    if (referralID !== null) {
      getReferral(referralID).then((referral) => {
        if (isMountedRef.current) {
          if (referral !== '{"Referrals":""}') {
            const referralJson = JSON.parse(referral).Referrals.Referral[0];
            const referralObj = {
              CreatedById: referralJson.CreatedById,
              DOB: referralJson.DOB,
              DateofReferral: referralJson.DateofReferral,
              DeferralReason: referralJson.DeferralReason,
              DynamicFields: referralJson.DynamicFields,
              FirstName: referralJson.FirstName,
              GenderText: referralJson.GenderText,
              GenderValue: referralJson.GenderValue,
              LastName: referralJson.LastName,
              MiddleName: referralJson.MiddleName,
              ReferralId: referralID,
              ReferringAgency: referralJson.ReferringAgency,
              ReferringAgencyId: referralJson.ReferringAgency,
              ReferringAgencyName: referralJson.ReferringAgencyName,
              SSN: referralJson.SSN,
              SOARContactId: referralJson.SOARContactId,
              ProposedProgram: referralJson.ProposedProgram,
              ProposedProgramName: referralJson.ProposedProgramName,
              SOARClientProgramId: referralJson.SOARClientProgramId,
              SOARClientProgramName: referralJson.SOARClientProgramName,
              Status: referralJson.Status,
              StatusChangeDate: referralJson.StatusChangeDate,
              ModifiedById: referralJson.ModifiedById,
            };
            setReferralData(referralObj);
            //if DynamicFields !== "" set Dynamic Data
            if (
              referralJson.DynamicFields !== "" &&
              referralJson.DynamicFields.results
            ) {
              setDynamicData(referralJson.DynamicFields.results);
              if (referralJson.DynamicFields.results.referringWorker)
                setReferringWorkerOptions([
                  {
                    _id: referralJson.DynamicFields.results.referringWorker
                      .value,
                    name: referralJson.DynamicFields.results.referringWorker
                      .text,
                  },
                ]);
            }
          } else {
            //navigate(-1);
          }

          setLoaded(true);
        }
      });
    }
  }, [referralID]);

  // Get Contact Info
  useEffect(() => {
    if (referralData.SOARContactId !== undefined) {
      getContact(referralData.SOARContactId).then((response) => {
        if (isMountedRef.current) {
          if (response) {
            setContact(response[0]);
            let refObj = { ...referralData };
            refObj = sync(refObj, "FirstName", response[0], "firstname");
            refObj = sync(refObj, "LastName", response[0], "lastname");
            refObj = sync(refObj, "MiddleName", response[0], "middlename");
            if (response[0]["birthdate"]) {
              refObj.birthdate = response[0]["birthdate"]["@date"];
            }
            refObj = sync(refObj, "SSN", response[0], "ccx_ssn");
            setReferralData(refObj);
          }

          setContactLoaded(true);
        }
      });
    }
  }, [referralData.SOARContactId, contactLoaded === false]);

  const sync = (obj, objField, contactObj, contactField) => {
    if (contactObj[contactField]) obj[objField] = contactObj[contactField];
    return obj;
  };

  //  Get SOAR Correspondence
  useEffect(
    () => {
      if (referralData.SOARContactId) {
        getSoarCorrespondence(referralData.SOARContactId).then((response) => {
          if (isMountedRef.current) {
            if (response) {
              setCorrespondence(response);
            }

            setCorrespondenceLoaded(true);
          }
        });
      } else {
        setCorrespondence([]);
        setCorrespondenceLoaded(true);
      }
    },
    [referralData.SOARContactId],
    correspondenceLoaded === false
  );

  useEffect(() => {
    // TODO: this seems like a relic useEffect
    if (loaded && programUnits.length > 0) {
      location.state = {
        businessUnitName: getFieldName(
          programUnits.filter(
            (unit) => unit.ccx_unitid === `{${referralData.ProposedProgram}}`
          )[0]["facility.ccx_agency"]
        ),
      };
    }
  }, [loaded, programUnits]);

  // #region Get User Program Units based on Date of Referral
  // useEffect(() => {
  //   if (
  //     referralData.ProposedProgram !== undefined &&
  //     (referralData.DynamicFields === "" || !referralData.DynamicFields.results)
  //   )
  //     getUserProgramUnits(safyInfo.user.safyInfo.BusinessUnitIdName).then((response) => {
  //       if (response && isMountedRef.current) {
  //         const selectedProgram = response.filter(
  //           (programUnit) =>
  //             programUnit.ccx_unitid === `{${referralData.ProposedProgram}}`
  //         );
  //         if (
  //           selectedProgram.length === 1 &&
  //           selectedProgram[0]["sor_referralconfig"]
  //         ) {
  //           const config = JSON.parse(selectedProgram[0]["sor_referralconfig"]);
  //           console.log("Config", config);
  //           const demographics = {
  //             demo: {
  //               type: "section",
  //               label: "Additional Demographics",
  //             },
  //             preferredGender: {
  //               type: "select",
  //               label: "Preferred Gender",
  //               text: "",
  //               value: "",
  //               options: contactOptionsets.sor_preferredgender,
  //             },
  //             consideryourselfhispaniclatino: {
  //               type: "checkbox",
  //               label: "Considered Hispanic or Latino",
  //               value: false,
  //               text: "false",
  //             },
  //             race: {
  //               type: "section",
  //               label: "Race",
  //             },
  //             americanindianoralaskanative: {
  //               type: "checkbox",
  //               label: "American Indian or Alaskan Native",
  //               value: false,
  //               text: "false",
  //             },
  //             nativehawaiianorotherpacificislander: {
  //               type: "checkbox",
  //               label: "Native Hawaiian or Pacific Islander",
  //               value: false,
  //               text: "false",
  //             },
  //             blackorafricanamerican: {
  //               type: "checkbox",
  //               label: "Black or African American",
  //               value: false,
  //               text: "false",
  //             },
  //             white: {
  //               type: "checkbox",
  //               label: "White",
  //               value: false,
  //               text: "false",
  //             },
  //             asian: {
  //               type: "checkbox",
  //               label: "Asian",
  //               value: false,
  //               text: "false",
  //             },
  //             primarylanguage: {
  //               type: "select",
  //               label: "Primary Language",
  //               text: "",
  //               value: "",
  //               options: contactOptionsets.sor_primarylanguage,
  //             },
  //           };
  //           const obj = { ...demographics, ...config.referral };
  //           setDynamicData(obj);
  //         }
  //       }
  //     });
  // }, [referralData]);
  // #endregion

  const handleChange = ({ currentTarget: input }) => {
    const errs = { ...errors };
    const errorMessage = validateProperty(input, joiSchema);
    if (errorMessage) {
      errs[input.name] = errorMessage;
    } else {
      delete errs[input.name];
    }
    const data = { ...referralData };
    data[input.name] = input.value;
    setReferralData(data);

    setErrors(errs);
  };

  const handleDynamicDataChange = ({ currentTarget: input }) => {
    const data = { ...dynamicData };
    if (input.name === "referringWorker") {
      const worker = referringWorkerOptions.filter(
        (w) => w._id === input.value
      )[0];
      if (!data[input.name]) {
        data[input.name] = {
          type: "referringWorker",
          value: input.value,
          text: worker.name,
        };
      } else {
        data[input.name].value = input.value;
        data[input.name].text = worker.name;
      }
    } else {
      if (!data[input.name]) {
        data[input.name] = {
          type: input.getAttribute("fieldtype"),
          value:
            input.type === "checkbox" ? input.checked.toString() : input.value,
          text:
            input.type === "checkbox"
              ? input.checked.toString()
              : input.value.toString(),
        };
      } else {
        data[input.name].value =
          input.type === "checkbox" ? input.checked.toString() : input.value;
        data[input.name].text =
          input.type === "checkbox"
            ? input.checked.toString()
            : input.value.toString();
      }
    }
    setDynamicData(data);
  };

  const cancel = () => {
    navigate(-1);
  };

  function convertDynamicData() {
    let dynamicObj = (
      "<results>" +
      json2xml(dynamicData, { compact: true, igonoreComment: true }) +
      "</results>"
    ).replaceAll("\n", "&#10;");

    return dynamicObj;
  }

  const handleSave = async (contactObj = { ...contact }) => {
    setForceContactSave(false);
    const toastId = toast.loading("Referral is being updated...", {
      type: toast.TYPE.INFO,
    });
    setContact({
      ...contact,
      firstname: contactObj.firstname,
      middlename: contactObj.middlename,
      lastname: contactObj.lastname,
      birthdate: contactObj.birthdate,
      ccx_ssn: contactObj.ccx_ssn,
    });

    //Set Referral Object's Contact Fields
    const refObj = { ...referralData };
    refObj.FirstName = contactObj.firstname;
    refObj.MiddleName = contactObj.middlename;
    refObj.LastName = contactObj.lastname;
    refObj.DOB = getFieldDate(contactObj.birthdate) || contact.birthdate;
    refObj.SSN = contactObj.ccx_ssn;

    const selectedGender = contactOptionsets.gendercode.filter(
      (option) => option._id === refObj.GenderValue
    )[0];

    const selectedAgency = referringAgencyOptions.filter(
      (option) => option._id === refObj.ReferringAgency
    )[0];

    const referral = {
      CreatedById: refObj.CreatedById,
      DOB:
        typeof refObj.DOB === "object"
          ? refObj.DOB["@date"]
          : typeof refObj.DOB === "string"
          ? refObj.DOB
          : "",
      DateofReferral: refObj.DateofReferral,
      DeferralReason: refObj.DeferralReason || "",
      DynamicFields: convertDynamicData(),
      FirstName: refObj.FirstName,
      GenderText: (selectedGender && selectedGender.name) || "",
      GenderValue: refObj.GenderValue || "",
      LastName: refObj.LastName,
      MiddleName: refObj.MiddleName || "",
      ModifiedById: safyInfo.user.azureId,
      ProposedProgram: refObj.ProposedProgram,
      ProposedProgramName: refObj.ProposedProgramName,
      ReferralId: referralID,
      ReferringAgencyId: refObj.ReferringAgency || "",
      ReferringAgencyName: (selectedAgency && selectedAgency.name) || "",
      SSN: refObj.SSN || "",
      Status: refObj.Status,
      StatusChangeDate: refObj.StatusChangeDate || new Date(),
      SOARContactId: refObj.SOARContactId || "",
      SOARClientProgramId: refObj.SOARClientProgramId || "",
      SOARClientProgramName: refObj.SOARClientProgramName || "",
    };

    let response;
    try {
      response = await saveReferral(referral, org, "Update");
      toast.update(toastId, {
        render: "Referral has been updated.",
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "An error occurred while updating the Referral.",
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
      writeLog(referral, "Update", response, error);
    }

    setReferralData(refObj);

    //// POP HISTORY
    // setTimeout(function () {
    //   console.log("History Go Back Timeout 1000");
    //   navigate(-1);
    // }, 1000);
  };

  const writeLog = (bodyObj, action, response, error) => {
    const responseJSON =
      response.constructor === Object ? response : JSON.parse(response);

    const fullError = {
      ...JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error))),
      responseJson: responseJSON,
    };

    const logData = {
      Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
      API: "Eureka API",
      APIBody: JSON.stringify(bodyObj),
      URL: `https://eurekaapi.azurewebsites.net/Component/Upsert/Referral/${org}/${action}/`,
      Org: logOrg,
      Application: `Referral - ${action}`,
      FullError: JSON.stringify(fullError),
      ResponseCode: responseJSON.SystemResponse?.[0]?.Code || "Unknown",
      ResponseMessage:
        responseJSON.SystemResponse?.[0]?.Response ||
        error.message ||
        "Unknown",
      ExceptionType: error.name || "Unknown",
    };
    writeErrorLog(logData);
  };

  const validateProperty = ({ name, value }, validationSchema) => {
    const obj = { [name]: value };
    const schema = { [name]: validationSchema[name] };
    const { error } = Joi.validate(obj, schema, { convert: true });
    return error ? error.details[0].message : null;
  };

  const getReferringAgencyOptions = () => {
    const options = referringAgencyOptions.filter(
      (option) =>
        referringAgencySearchQuery === "" ||
        option.name
          .toLowerCase()
          .includes(referringAgencySearchQuery.toLowerCase())
    );

    return options;
  };

  const handleHideRequestAgencyModal = () => {
    setAgencyInfo("");
    setIsRequestAgencyOpen(false);
  };

  const sendRequestingEmail = () => {
    handleHideRequestAgencyModal();
    sendEmail(
      "support@safy.org",
      safyInfo.user.email,
      "SAFY Portal - New Referring Agency Request",
      ` ${safyInfo.user.displayName} has submitted the following request for a new referring agency.<br/><br/>${agencyInfo}`
    ).then(() => {
      toast.success("Email requesting new referring agency sent");
    });
  };

  const handleHideReferralDecisionModal = () => {
    setIsReferralDecisionOpen(false);
  };

  const handleReferringWorkerSearch = async () => {
    const response = await searchContact(
      referringWorkerSearchQuery,
      safyInfo.user.safyInfo.BusinessUnitIdName
    );

    if (!isMountedRef.current || !response) {
      return;
    }

    const options = response.map((item) => {
      return {
        _id: item.contactid,
        name: `${item.fullname}${
          item.birthdate ? " - DOB: " + getFieldDate(item.birthdate) : ""
        }`,
      };
    });
    setReferringWorkerOptions(options);
  };

  const handleReferringWorkerChange = ({ currentTarget: input }) => {
    const errs = { ...referringWorkerErrors };
    const errorMessage = validateProperty(input, referringWorkerSchema);

    if (errorMessage) {
      errs[input.name] = errorMessage;
    } else {
      delete errs[input.name];
    }
    setReferringWorkerErrors(errs);

    const obj = { ...referringWorkerData };
    obj[input.name] = input.value;
    setReferringWorkerData(obj);
  };

  const validateReferringWorker = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(
      referringWorkerData,
      referringWorkerSchema,
      options
    );

    let validationErrors = {};
    if (error) {
      for (let item of error.details)
        validationErrors[item.path[0]] = item.message;
    }

    setReferringWorkerErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSaveReferringWorker = async () => {
    setIsReferringWorkerOpen(false);
    const obj = {
      firstname: {
        type: "string",
        value: referringWorkerData.FirstName,
      },
      lastname: {
        type: "string",
        value: referringWorkerData.LastName,
      },
      ccx_contacttype: {
        type: "optionset",
        value: 229580006, // County Worker
      },
      emailaddress1: {
        type: "string",
        value: referringWorkerData.Email,
      },
      mobilephone: {
        type: "string",
        value: referringWorkerData.MobilePhone,
      },
    };

    if (referringWorkerData.DateOfBirth) {
      obj.birthdate = {
        type: "datetime",
        value: new Date(referringWorkerData.DateOfBirth),
      };
    }

    if (referringWorkerData.County) {
      obj.parentcustomerid = {
        type: "entity",
        value: {
          entityName: "account",
          entityId: referringWorkerData.County,
        },
      };
    }

    const toastId = toast.loading("Contact is being created...", {
      type: toast.TYPE.INFO,
    });

    const company = programUnits.filter(
      (unit) => unit.ccx_unitid === `{${referralData.ProposedProgram}}`
    )[0].owningbusinessunit;

    let response;

    try {
      response = await createEntity(
        "contact",
        JSON.stringify(obj),
        safyInfo,
        getFieldName(company).split(" of ")[1]
      );

      toast.update(toastId, {
        render: "Contact has been created.",
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });

      const newOption = {
        _id: response.resultset.result.contactid,
        name: response.resultset.result.fullname,
      };

      setReferringWorkerOptions(
        [...referringWorkerOptions, newOption].sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        })
      );
      setDynamicData({
        ...dynamicData,
        referringWorker: {
          type: "referringWorker",
          value: response.resultset.result.contactid,
          text: response.resultset.result.fullname,
        },
      });
      setReferringWorkerData({});
    } catch {
      toast.update(toastId, {
        render: "An error occurred while creating the Contact.",
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    }
  };

  const addNew = () => {
    navigate("/correspondence", {
      state: {
        contact: contact,
      },
    });
  };

  const openContact = () => {
    const url =
      process.env.REACT_APP_ORG +
      "/main.aspx?etc=2&extraqs=formid%3ddce13c2e-cc2a-4081-9921-df8dfaefcfac&id=" +
      contact.contactid +
      "&pagetype=entityrecord";
    window.open(url, "contact");
  };

  return (
    <>
      <ReferralDecisionModal
        isOpen={isReferralDecisionOpen}
        referralData={referralData}
        setReferralData={setReferralData}
        dynamicData={dynamicData}
        setDynamicData={setDynamicData}
        referralStatus={referralStatus}
        programUnitOptions={programUnitOptions}
        programUnits={programUnits}
        hideModal={handleHideReferralDecisionModal}
      ></ReferralDecisionModal>
      {isRequestAgencyOpen ? (
        <Modal show={isRequestAgencyOpen} animation={false}>
          <Modal.Header>
            <Modal.Title>Request Referring Agency</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TextArea
              name="AgencyInfo"
              label="Enter information about Agency to add"
              onChange={(e) => {
                setAgencyInfo(e.currentTarget.value);
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <>
              <button
                className="btn btn-danger"
                onClick={handleHideRequestAgencyModal}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  sendRequestingEmail();
                }}
              >
                Submit
              </button>
            </>
          </Modal.Footer>
        </Modal>
      ) : null}
      {isReferringWorkerOpen ? (
        <Modal show={isReferringWorkerOpen} animation={false}>
          <Modal.Header>
            <Modal.Title>Referring Worker</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Input
              name="FirstName"
              label="First Name"
              value={referringWorkerData.FirstName}
              onChange={handleReferringWorkerChange}
              error={referringWorkerErrors.FirstName}
            />
            <Input
              name="LastName"
              label="Last Name"
              value={referringWorkerData.LastName}
              onChange={handleReferringWorkerChange}
              error={referringWorkerErrors.LastName}
            />
            <Input
              name="Email"
              label="Email"
              value={referringWorkerData.Email}
              onChange={handleReferringWorkerChange}
              error={referringWorkerErrors.Email}
            />
            <PhoneInput
              name="MobilePhone"
              label="Mobile Phone"
              value={referringWorkerData.MobilePhone}
              onChange={handleReferringWorkerChange}
              error={referringWorkerErrors.MobilePhone}
            />
            <Input
              name="DateOfBirth"
              label="Date of Birth"
              value={referringWorkerData.DateOfBirth}
              onChange={handleReferringWorkerChange}
              type="date"
            />
            <Select
              name="Gender"
              label="Gender"
              value={referringWorkerData.Gender}
              options={contactOptionSets.sor_preferredgender}
              onChange={handleReferringWorkerChange}
            />
            <Select
              name="County"
              label="County"
              value={referringWorkerData.County}
              options={referringAgencyOptions}
              onChange={handleReferringWorkerChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <>
              <button
                className="btn btn-danger mx-1"
                onClick={() => {
                  setIsReferringWorkerOpen(false);
                  setReferringWorkerErrors({});
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary mx-1"
                onClick={() => {
                  if (validateReferringWorker()) handleSaveReferringWorker();
                }}
              >
                Submit
              </button>
            </>
          </Modal.Footer>
        </Modal>
      ) : null}
      <div>
        {!loaded ? (
          <>
            <div className="d-flex justify-content-center align-items-center">
              <h1>LOADING REFERRAL</h1>
              <Lottie
                animationData={referralLoading.default}
                loop={true}
                autoplay={true}
                rendererSettings={{
                  preserveAspectRatio: "xMidYMid slice",
                }}
                height={120}
                width={120}
              />
            </div>
          </>
        ) : (
          <>
            {/* 
              // Documents Location deprecated
            <DocumentsIcon
              clientDocInfo={
                contact && contact.doclocation ? contact.doclocation[0] : {}
              }
            /> */}
            <div className="row">
              <div className="col">
                {referralData.Status === "Accepted" && (
                  <div className="text-safy-success">
                    This referral was accepted on{" "}
                    {moment(referralData.StatusChangeDate).format("LL")}.
                  </div>
                )}
                {referralData.Status === "Deferred" && (
                  <div className="text-danger">
                    This referral was deferred on{" "}
                    {moment(referralData.StatusChangeDate).format("LL")}
                    {dynamicData.deferralReasons !== undefined &&
                      dynamicData.deferralReasons.value !== undefined &&
                      dynamicData.deferralReasons.value !== "" &&
                      ` with
                      the reason ${dynamicData.deferralReasons.value}`}
                    .
                  </div>
                )}
              </div>
            </div>
            <div className="bg-safy2-1 text-white p-4 rounded mb-4">
              <div className="row">
                <div
                  className="col h4"
                  onClick={openContact}
                  style={{ cursor: "pointer" }}
                >{`${referralData.FirstName} ${referralData.LastName}`}</div>
                <div className="col">
                  <div className="float-end bg-white rounded">
                    <button
                      className="btn btn-danger m-2 float-end"
                      onClick={() => {
                        cancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className={
                        Object.keys(errors).length === 0
                          ? "btn btn-primary m-2 float-end"
                          : "btn btn-secondary m-2 float-end"
                      }
                      onClick={() => handleSave()}
                    >
                      Save
                    </button>
                    <button
                      className="btn btn-warning m-2 float-end"
                      onClick={() => {
                        setReferralStatus("Deferred");
                        setIsReferralDecisionOpen(true);
                      }}
                    >
                      Defer
                    </button>
                    <button
                      className="btn btn-success m-2 float-end"
                      onClick={() => {
                        setReferralStatus("Accepted");
                        setIsReferralDecisionOpen(true);
                      }}
                      disabled={referralData.Status !== "Pending"}
                    >
                      Accept
                    </button>
                    <button
                      className="btn m-2 float-end text-white"
                      style={{ backgroundColor: "purple" }}
                      onClick={() => {
                        setReferralStatus("Transfer");
                        setIsReferralDecisionOpen(true);
                      }}
                      disabled={referralData.Status !== "Pending"}
                    >
                      Transfer
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="h4">Referral Detail</div>
            <div className="row">
              <div className="col-9">
                <Input
                  name="ProposedProgramName"
                  label="Program Unit"
                  value={referralData.ProposedProgramName}
                  error={errors.ProposedProgram}
                  disabled
                />
              </div>
              <div className="col">
                <Input
                  name="DateofReferral"
                  label="Date of Referral"
                  type="date"
                  value={
                    referralData.DateofReferral &&
                    formatDate(referralData.DateofReferral)
                  }
                  onChange={handleChange}
                  error={errors.DateofReferral}
                  disabled={referralData.Status !== "Pending"}
                  className="w-100"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <Input
                  name="ReferringAgencySearchQuery"
                  label="Search for Agency"
                  placeholder="Search for Agency..."
                  onChange={(e) => {
                    setReferringAgencySearchQuery(e.currentTarget.value);
                  }}
                  disabled={referralData.Status !== "Pending"}
                />
              </div>
              <div className="col-1 pt-3">
                <button
                  className="btn btn-primary mt-3"
                  style={{ marginTop: "30px" }}
                  onClick={handleReferringWorkerSearch}
                  disabled={referringWorkerSearchQuery === ""}
                >
                  Search
                </button>
              </div>
              <div className="col">
                <Select
                  name="ReferringAgency"
                  label={
                    <>
                      Referring Agency{" "}
                      <i
                        className="far fa-plus-square fa-md text-primary"
                        title="Request New Agency"
                        onClick={() => {
                          setIsRequestAgencyOpen(true);
                        }}
                      ></i>
                    </>
                  }
                  options={getReferringAgencyOptions()}
                  value={referralData.ReferringAgency}
                  onChange={handleChange}
                  disabled={
                    referralData.Status !== "Pending" ||
                    getReferringAgencyOptions().length === 0
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <Input
                  name="ReferringWorkerSearchQuery"
                  label="Search for Worker"
                  placeholder="Search for Worker..."
                  onChange={(e) => {
                    setReferringWorkerSearchQuery(e.currentTarget.value);
                  }}
                  disabled={referralData.Status !== "Pending"}
                />
              </div>
              <div className="col-1 pt-3">
                <button
                  className="btn btn-primary mt-3"
                  onClick={handleReferringWorkerSearch}
                  disabled={referringWorkerSearchQuery === ""}
                >
                  Search
                </button>
              </div>
              <div className="col">
                <Select
                  name="referringWorker"
                  label={
                    <>
                      Referring Worker{" "}
                      <i
                        className="far fa-plus-square fa-md text-primary"
                        onClick={() => {
                          setIsReferringWorkerOpen(true);
                        }}
                      />
                    </>
                  }
                  options={referringWorkerOptions}
                  value={
                    dynamicData["referringWorker"]
                      ? dynamicData["referringWorker"]["value"]
                      : ""
                  }
                  onChange={handleDynamicDataChange}
                  disabled={referralData.Status !== "Pending"}
                />
              </div>
            </div>
            <TextArea
              name="notes"
              label="Referral Notes"
              value={dynamicData["notes"] ? dynamicData["notes"]["value"] : ""}
              fieldtype="notes"
              onChange={handleDynamicDataChange}
            />
            <div className="bg-light border p-2 mb-4">
              {activeTab !== "Correspondence" ? (
                <div className="clearfix">
                  <div className="float-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        if (activeTab === "ClientInfo") {
                          setForceContactSave(true);
                        } else if (activeTab === "ReferralForm") {
                          handleSave();
                        }
                      }}
                    >
                      Save{" "}
                      {activeTab === "ClientInfo" ? "Contact" : "Referral Form"}
                    </button>
                  </div>
                </div>
              ) : null}
              <Tabs
                activeKey={activeTab}
                id="referral-tabs"
                className="reftabs mb-4"
                transition={false}
                onSelect={(key) => setActiveTab(key)}
              >
                <Tab
                  eventKey="ClientInfo"
                  title="Client Info"
                  className="ref-tabs"
                >
                  {activeTab === "ClientInfo" ? (
                    <>
                      {referralData.SOARContactId !== undefined ? (
                        <Contact
                          propContactID={referralData.SOARContactId}
                          postSave={handleSave}
                          forceSave={forceContactSave}
                        ></Contact>
                      ) : (
                        "No Client record for this Referral"
                      )}
                    </>
                  ) : null}
                </Tab>
                <Tab
                  eventKey="ReferralForm"
                  title="Referral Form"
                  className="ref-tabs"
                >
                  {activeTab === "ReferralForm" ? (
                    <ReferralCustomRender
                      data={referralData}
                      setData={setReferralData}
                      handleSave={handleSave}
                    ></ReferralCustomRender>
                  ) : null}
                </Tab>
                <Tab
                  eventKey="Correspondence"
                  title="SOAR Correspondence"
                  className="ref-tabs"
                >
                  {!correspondenceLoaded && referralData.SOARContactId ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <h1>LOADING CLIENT INFO</h1>
                      <Lottie
                        animationData={referralLoading.default}
                        loop={true}
                        autoplay={true}
                        rendererSettings={{
                          preserveAspectRatio: "xMidYMid slice",
                        }}
                        height={120}
                        width={120}
                      />
                    </div>
                  ) : null}
                  {correspondenceLoaded ? (
                    <EntityHeader
                      title={
                        correspondence.length > 0
                          ? "SOAR Correspondences"
                          : "No SOAR Correspondences"
                      }
                      add={addNew}
                      body={
                        <>
                          {correspondence.map((cor) => (
                            <div
                              className="p-2"
                              key={cor.sor_soarcorrespondanceid}
                            >
                              <SOARCorrespondenceCard correspondence={cor} />
                            </div>
                          ))}
                        </>
                      }
                    ></EntityHeader>
                  ) : null}
                </Tab>
                <Tab
                  eventKey="documents"
                  title="Documents"
                  className="ref-tabs"
                >
                  {programUnits?.length > 0 && (
                    <Documents
                      id={referralData.SOARContactId}
                      type="ClientID"
                      state={
                        programUnits.find((pu) =>
                          pu.ccx_unitid
                            .toUpperCase()
                            .includes(
                              referralData.ProposedProgram.toUpperCase()
                            )
                        )
                          ? programUnits
                              .find((pu) =>
                                pu.ccx_unitid
                                  .toUpperCase()
                                  .includes(
                                    referralData.ProposedProgram.toUpperCase()
                                  )
                              )
                              ["facility.ccx_agency"]["@name"].replace(
                                "SAFY of ",
                                ""
                              )
                          : null
                      }
                      puconfig={
                        programUnits.find((pu) =>
                          pu.ccx_unitid
                            .toUpperCase()
                            .includes(
                              referralData.ProposedProgram.toUpperCase()
                            )
                        )?.sor_safyportalconfig
                          ? JSON.parse(
                              programUnits.find((pu) =>
                                pu.ccx_unitid
                                  .toUpperCase()
                                  .includes(
                                    referralData.ProposedProgram.toUpperCase()
                                  )
                              ).sor_safyportalconfig || {}
                            )
                          : {}
                      }
                    />
                  )}
                </Tab>
              </Tabs>
            </div>
            {/* {Object.keys(dynamicData).length > 0 && (
              <>
                <div>
                  {Object.keys(dynamicData).map((element) => {
                    if (
                      dynamicData[element] !== null &&
                      dynamicData[element] !== undefined
                    )
                      switch (dynamicData[element]["type"]) {
                        case "deferralReasons":
                          return;
                        case "notes":
                          return;
                        case "referringWorker":
                          return;
                        case "date":
                          return (
                            <Input
                              className={
                                `${dynamicData[element]["@style"]} mb-4` || ""
                              }
                              key={`d${element}`}
                              name={element}
                              label={dynamicData[element]["label"]}
                              value={dynamicData[element]["value"]}
                              onChange={handleDynamicDataChange}
                              type="date"
                              disabled={referralData.Status !== "Pending"}
                            />
                          );
                        case "select":
                          return (
                            <Select
                              className={
                                `${dynamicData[element]["@style"]} mb-4` || ""
                              }
                              name={element}
                              options={dynamicData[element]["options"]}
                              label={dynamicData[element]["label"]}
                              value={dynamicData[element]["value"]}
                              onChange={handleDynamicDataChange}
                              key={`sel${element}`}
                              disabled={referralData.Status !== "Pending"}
                            />
                          );
                        case "input":
                          return (
                            <Input
                              className={
                                `${dynamicData[element]["@style"]} mb-4` || ""
                              }
                              key={`in${element}`}
                              name={element}
                              label={dynamicData[element]["label"]}
                              value={dynamicData[element]["value"]}
                              onChange={handleDynamicDataChange}
                              disabled={referralData.Status !== "Pending"}
                            />
                          );
                        case "checkbox":
                          return (
                            <div className="mb-4 ps-4" key={`cb${element}`}>
                              <Checkbox
                                name={element}
                                label={dynamicData[element]["label"]}
                                checked={
                                  dynamicData[element]["value"] === "true"
                                }
                                onChange={handleDynamicDataChange}
                                disabled={referralData.Status !== "Pending"}
                              />
                            </div>
                          );
                        case "section":
                          return (
                            <div key={`sect${element}`} className="h5 mb-4">
                              {dynamicData[element]["label"]}
                            </div>
                          );
                        default:
                          return <div key={`def${element}`}>FAIL: {JSON.stringify(element)}</div>;
                      }
                    else return null;
                  })}
                </div>
              </>
            )} */}
          </>
        )}
      </div>
    </>
  );
};

export default Referral;
